import { Subject } from 'rxjs'
export const uploadObservers = new Subject()
export const connectionObservers = new Subject()
export const connectedObservers = new Subject()
export const copyFileObservers = new Subject()
export const createFileObservers = new Subject()
export const createGroupFolderObservers = new Subject()
export const approveGroupFolderObservers = new Subject()
export const sharedFileObservers = new Subject()
export const createInsideGroupFolderObservers = new Subject()
